/* eslint-disable indent */
import { APIs } from "../../utils/worker";
import API from "../../api";

const { bffBaseURL } = APIs;

const urls = {
  BASE_NOTIFICATION_TOPIC: `${bffBaseURL}/notification-service/v1/topics`,
  NOTIFICATION_CREATE_TOPIC: `${bffBaseURL}/notification-service/v1/topic`,
  NOTIFICATION_CONFIGURE_LIST: `${bffBaseURL}/notification-service/v1/notifications`,
  NOTIFICATION_EVENT_TYPE: `${bffBaseURL}/notification-service/v1/event-types`,
  NOTIFICATION_CREATE: `${bffBaseURL}/notification-service/v1/notification`,
};

const handleApiRequest = async (
  url,
  method,
  data = null,
  headersMethod = "get"
) => {
  try {
    const payload = data;

    const headers = headersMethod;

    let response = await API.Api(url)[method](payload, headers);
    return response;
  } catch (error) {
    console.error(`Error in ${method.toUpperCase()} request to ${url}:`, error);
    throw error;
  }
};

// const handleApiRequestCustomHeader = async (
//   url,
//   method,
//   data = null,
//   header
// ) => {
//   try {
//     const payload = data;
//     let response = await API.Api(url)[method](payload, header);
//     return response;
//   } catch (error) {
//     console.error(`Error in ${method.toUpperCase()} request to ${url}:`, error);
//     throw error;
//   }
// };
export const notificationTopicApi = {
  getNotificationTopic: () =>
    handleApiRequest(urls.BASE_NOTIFICATION_TOPIC, "get"),

  getNotificationTopicDetails: (id) =>
    handleApiRequest(`${urls.NOTIFICATION_CREATE_TOPIC}/${id}`, "get"),

  postNotificationTopic: (payload) =>
    handleApiRequest(urls.NOTIFICATION_CREATE_TOPIC, "post", payload),

  patchNotificationTopic: (id, payload) =>
    handleApiRequest(
      `${urls.NOTIFICATION_CREATE_TOPIC}/${id}`,
      "patch",
      payload
    ),

  putNotificationTopic: (id, payload) =>
    handleApiRequest(`${urls.NOTIFICATION_CREATE_TOPIC}/${id}`, "put", payload),

  deleteNotificationTopic: (id) =>
    handleApiRequest(`${urls.NOTIFICATION_CREATE_TOPIC}/${id}`, "deleteHeader"),
};

export const notificationConfigureApi = {
  getNotificationConfigure: (params) => {
    const queryParams = new URLSearchParams(params).toString();

    return handleApiRequest(
      `${urls.NOTIFICATION_CONFIGURE_LIST}?${queryParams}`,
      "get"
    );
  },
  //handleApiRequest(urls.NOTIFICATION_CONFIGURE_LIST, "get"),

  getNotificationConfigureDetails: (id) =>
    handleApiRequest(`${urls.NOTIFICATION_CREATE}/${id}`, "get"),

  getNotificationEventType: () =>
    handleApiRequest(urls.NOTIFICATION_EVENT_TYPE, "get"),

  postNotificationConfigure: (payload) =>
    handleApiRequest(urls.NOTIFICATION_CREATE, "post", payload),

  putNotificationConfigure: (id, payload) =>
    handleApiRequest(`${urls.NOTIFICATION_CREATE}/${id}`, "put", payload),
};
